import { useLocation, useNavigate } from 'react-router-dom';
import { cn } from '../utils/cn';
import { isNavItemActive, NavigationItem } from '../config/navigation';

interface MobileBottomNavProps {
  favoriteItems: NavigationItem[];
  /** When set (Tesseract-only users), use these instead of favourites for the bottom bar. */
  limitedNavItems?: NavigationItem[] | null;
}

const MAX_DRAWER_ITEMS = 5;

export const MobileBottomNav = ({
  favoriteItems,
  limitedNavItems,
}: MobileBottomNavProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const bottomNavItems = (
    limitedNavItems && limitedNavItems.length > 0
      ? limitedNavItems
      : favoriteItems
  ).slice(0, MAX_DRAWER_ITEMS);

  const handleTap = (item: NavigationItem) => {
    navigate(item.path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-[var(--surface-drawer)] backdrop-blur-2xl border-t border-glass-200/15 pb-safe" aria-label="Quick navigation">
      <div className="flex items-stretch justify-around h-14 px-1">
        {bottomNavItems.map((item) => {
          const Icon = item.icon;
          const active = isNavItemActive(item, location.pathname);
          return (
            <button
              key={item.id}
              onClick={() => handleTap(item)}
              className={cn(
                'relative flex flex-col items-center justify-center flex-1 min-w-0 my-1.5 rounded-lg touch-manipulation',
                'transition-colors duration-150',
                active ? 'text-accent-300 bg-accent-500/15' : 'text-glass-400 active:bg-glass-200/10'
              )}
              aria-current={active ? 'page' : undefined}
            >
              <Icon className="w-5 h-5" />
              <span className={cn(
                'text-[10px] mt-0.5 font-medium truncate max-w-full px-1',
                active ? 'text-accent-300' : 'text-glass-400'
              )}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
